












import Component from 'vue-class-component';
import '@/plugins/Modal';
import {Mixins} from 'vue-property-decorator';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import MessageUtils from '@/utils/MessageUtils';

@Component({
    components: {CommonButton, CommonPromptDialog},
    mixins: [DialogEventsMixin]
})
export default class SessionTimeoutWarningDialog extends Mixins<DialogEventsMixin>(DialogEventsMixin) {
    private dialogVisible = false;
    
    get isVisible() {
        return this.dialogVisible;
    }
    
    set isVisible(param) {
        this.dialogVisible = false;
    }
    
    public extend() {
        this.$store.commit('extendSessionTime');
        this.hide();
    }
    
    public ignore() {
        MessageUtils.displayErrorMessage(this.$t('message.sessionTimeoutDialog.sessionWillBeExpired').toString(), {
            duration: 2000
        });

        this.$store.commit('rejectSessionExtension');
        this.hide();
    }
    
    public show() {
        if (this.dialogVisible) {
            return;
        }
        this.dialogVisible = true;
    }
    
    public hide() {
        this.dialogVisible = false;
    }

    public mounted() {
        this.$modal
            .getEventBus()
            .$on('showSessionTimeoutWarningDialog', () => {
                this.show();
            });
    }

    public destroyed() {
        this.$modal.getEventBus().$off('showSessionTimeoutWarningDialog');
    }
}
